<div class="container">
  <div class="content-box">
    <div class="row">
      <div class="col-xs-12">
        <h4>{{ 'STOP_COOKIES.MENU_TITLE'|translate }}</h4>
      </div>
    </div>

    <ag-stop-cookies *ngIf="companyId" [companyId]="companyId"></ag-stop-cookies>
  </div>
</div>
